import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appWholeNumberValidate][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: WholeNumberValidateDirective, multi: true }
  ]
})
export class WholeNumberValidateDirective implements Validator {

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == null || value == '')
      return;

    const validationKey = 'wholenumber';
    
    try {
      BigInt(value);
    }
    catch {
      return { [validationKey]: true };
    }

    return null;
  }
}